export const Circle = ({ width = '21', height = '20', fill = '#CAF413' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="10.5"
        cy="10"
        r="9.66667"
        stroke="#5A5A5A"
        strokeWidth="0.666667"
      />
      <mask id="path-2-inside-1_255_203" fill="white">
        <path d="M20.5005 10C20.5005 15.5228 16.0233 20 10.5005 20C4.97764 20 0.500488 15.5228 0.500488 10C0.500488 4.47715 4.97764 0 10.5005 0C16.0233 0 20.5005 4.47715 20.5005 10ZM1.95837 10C1.95837 14.7177 5.78281 18.5421 10.5005 18.5421C15.2182 18.5421 19.0426 14.7177 19.0426 10C19.0426 5.28232 15.2182 1.45789 10.5005 1.45789C5.78281 1.45789 1.95837 5.28232 1.95837 10Z" />
      </mask>
      <path
        d="M20.5005 10C20.5005 15.5228 16.0233 20 10.5005 20C4.97764 20 0.500488 15.5228 0.500488 10C0.500488 4.47715 4.97764 0 10.5005 0C16.0233 0 20.5005 4.47715 20.5005 10ZM1.95837 10C1.95837 14.7177 5.78281 18.5421 10.5005 18.5421C15.2182 18.5421 19.0426 14.7177 19.0426 10C19.0426 5.28232 15.2182 1.45789 10.5005 1.45789C5.78281 1.45789 1.95837 5.28232 1.95837 10Z"
        stroke={fill}
        strokeWidth="2.66667"
        strokeLinejoin="round"
        mask="url(#path-2-inside-1_255_203)"
      />
      <g clipPath="url(#clip0_255_203)">
        <path
          d="M15.1586 9.17496C15.6142 9.63057 15.6142 10.3693 15.1586 10.8249C14.703 11.2805 13.9643 11.2805 13.5087 10.8249C13.0531 10.3693 13.0531 9.63057 13.5087 9.17496C13.9643 8.71935 14.703 8.71935 15.1586 9.17496Z"
          fill={fill}
        />
        <path
          d="M11.6586 9.17496C12.1142 9.63057 12.1142 10.3693 11.6586 10.8249C11.203 11.2805 10.4643 11.2805 10.0087 10.8249C9.55309 10.3693 9.55309 9.63057 10.0087 9.17496C10.4643 8.71935 11.203 8.71935 11.6586 9.17496Z"
          fill={fill}
        />
        <path
          d="M8.15861 9.17496C8.61422 9.63057 8.61422 10.3693 8.15861 10.8249C7.703 11.2805 6.96431 11.2805 6.5087 10.8249C6.05309 10.3693 6.05309 9.63057 6.5087 9.17496C6.96431 8.71935 7.703 8.71935 8.15861 9.17496Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_255_203">
          <rect
            width="9.33333"
            height="9.33333"
            fill="white"
            transform="translate(6.16699 5.33325)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
